import InvoiceDetailPage from './InvoiceDetailPage';

export function Route() {
  return <InvoiceDetailPage />;
}
